import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CangePassword from "../../parts/dashboard/changePassword";

/**
 * First-time ESS password change (blocking until session flag clears).
 */
const EssChangePassword = () => {
  const navigate = useNavigate();

  return (
    <Box minH="100vh" bg="gray.50" py={12} px={4}>
      <Container maxW="md">
        <VStack spacing={6} align="stretch">
          <Box textAlign="center">
            <Heading size="lg">Set your password</Heading>
            <Text color="gray.600" mt={2} fontSize="sm">
              You must update your password before continuing to the employee portal.
            </Text>
          </Box>
          <Box bg="white" borderRadius="lg" p={6} shadow="sm" border="1px solid" borderColor="gray.200">
            <CangePassword
              isEnterprise={false}
              close={() => navigate("/ess", { replace: true })}
            />
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default EssChangePassword;
